<ngx-datatable #BookkeepingTable [rows]="invoices" [messages]="{emptyMessage: ''}" [trackByProp]="'id'"
  class="material expandable custom bookkeepingTable sd-list" [columnMode]="columnMode.force" [scrollbarV]="false"
  [scrollbarH]="false" [headerHeight]="40" [footerHeight]="(!infiniteScroll && (status == 'Processed' || status == 'Combined') && maxCount > 0) ? 50 : 0"
  rowHeight="auto" [limit]="(!infiniteScroll && (status == 'Processed' || status == 'Combined')) ? pageSize : invoices.length" (activate)="onActivate($event)"
  (sort)="onSort($event)">

  <!-- Checkbox -->
  <ngx-datatable-column name="Checker" [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false"
    [resizeable]="false">
    <ng-template [width]="30" let-row="row" ngx-datatable-header-template>
      <input type="checkbox" class="header-checkbox" name="chkHeader" [(ngModel)]="isHeaderCheckboxSelected"
        (change)="onHeaderCheckboxChange()">
    </ng-template>
    <ng-template [width]="30" let-row="row" ngx-datatable-cell-template>
      <input type="checkbox" [(ngModel)]="row.checked" (change)="onCheckboxChange($event, row)" class="checkbox">
    </ng-template>
  </ngx-datatable-column>

  <!-- Supplier -->
  <ngx-datatable-column *ngIf="isColumnDisplayed('supplier')" name="Supplier" prop="supplierName" 
    [width]="screenBrakepoint == screenBrakepoints.MinWidth769px ? 200 : screenBrakepoint == screenBrakepoints.MaxWidth768px ? 250 : 200">
    <ng-template ngx-datatable-header-template>
      <div class="column-header">
        <span class="column-label">Supplier</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('supplier', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('supplier', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open supplier filters"></i> -->
      </div>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template [width]="screenBrakepoint == screenBrakepoints.MinWidth769px ? 250 : 200">
      <div class="supplier" *ngIf="row?.supplierName != ''">
        <div class="sup_img_box_processing" *ngIf="row.rowCount == 0 && !row.id">
          <img src="../../../../../assets/img/inboxPage/analyze.gif" alt="">
        </div>
        <!-- <div class="sup_img_box" *ngIf="row.rowCount != 0"
          [ngClass]="{'sup_img_box_1': row.rowCount == 1,'sup_img_box_2': row.rowCount == 2,'sup_img_box_3': row.rowCount ==3,'sup_img_box_4': row.rowCount == 4,'sup_img_box_5': row.rowCount == 5,'sup_img_box_6': row.rowCount == 6}">
          <span>{{row.shortCode}}</span>
        </div> -->
        <app-supplier-avatar class="sup_img_box {{row.hexColorClass}}"
          *ngIf="row.rowCount != 0 && row?.supplierName != null && row.hexColorClass != null"
          [supplierId]="row.supplierId" [supplierName]="row.supplierName">
          <span>{{row?.shortCode}}</span>
        </app-supplier-avatar>
        <app-supplier-avatar class="sup_img_box" *ngIf="row.rowCount != 0 && row?.supplierName != null && row.hexColorClass == null"
          [supplierId]="row.supplierId" [supplierName]="row.supplierName"
          [ngClass]="{'sup_img_box_1': row.rowCount == 1 && row.hexColorClass == null,
                    'sup_img_box_2': row.rowCount == 2 && row.hexColorClass == null,
                    'sup_img_box_3': row.rowCount == 3 && row.hexColorClass == null,
                    'sup_img_box_4': row.rowCount == 4 && row.hexColorClass == null,
                    'sup_img_box_5': row.rowCount == 5 && row.hexColorClass == null,
                    'sup_img_box_6': row.rowCount == 6 && row.hexColorClass == null}">
          <span>{{row?.shortCode}}</span>
        </app-supplier-avatar>
        <div class="sup_img_box" *ngIf="row.rowCount != 0 && (row?.supplierName == null || row?.supplierName == '')"
          [ngClass]="{'sup_img_box_1': row.rowCount == 1,'sup_img_box_2': row.rowCount == 2,'sup_img_box_3': row.rowCount ==3,'sup_img_box_4': row.rowCount == 4,'sup_img_box_5': row.rowCount == 5,'sup_img_box_6': row.rowCount == 6}">
          <span>{{row?.shortCode}}</span>
        </div>
        <div class="sup_det">
          <div class="sd_name">
            <span class="name" *ngIf="row.supplierName">{{row.supplierName}}</span>
            <span class="name field-placeholder" *ngIf="!row.supplierName">Add Supplier name</span>
            <div *ngIf="!row.isDemo && (status === statuses.inProcessing && row.contactStatus)" class="clsContStatus">
              {{row.contactStatus}}</div>
            <div *ngIf="row.isDemo && status === statuses.inProcessing" class="clsDemo">Demo</div>
            <!--<img *ngIf="row?.submissionMethod == 3" src="../../../../../assets/img/inboxPage/addin.png" alt="Submitted via Inbox Assistant" class="addin-logo" title="Submitted via Inbox Assistant" />-->

          </div>
          <span class="sd_invoice invoice-number">{{row.invoiceNumber}}
            <!-- Combined view shows For Review + Processed together, so each
                 row needs to declare which it is. -->
            <span class="row-type-pill"
              *ngIf="status === statuses.combined"
              [ngClass]="row.isProcessed ? 'row-type-pill--processed' : 'row-type-pill--review'">
              {{ row.isProcessed ? 'Processed' : 'For Review' }}
            </span>
            <app-status-pill
              *ngIf="(status === statuses.processed || (status === statuses.combined && row.isProcessed)) && getIntegrationType() !== 'None' && (row.status && row.status != '')"
              [status]="getPlaceholderStatus(row)" [integrationType]="getIntegrationType()" [showIcon]="true">
            </app-status-pill>
          </span>
          <div class="sd-mobile" *ngIf="screenBrakepoint != screenBrakepoints.MinWidth769px">
            <span class="sd_invoice invoice-number">{{row.date | formatedDate}}</span>
            <span class="sd_invoice invoice-number" *ngIf="row.accountName">&nbsp;|&nbsp;{{row.accountName}}</span>
          </div>
        </div>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <!-- Date -->
  <ngx-datatable-column *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && isColumnDisplayed('date')" prop="date" name="Date" [width]="90">
    <ng-template ngx-datatable-header-template>
      <div class="column-header">
        <span class="column-label">Date</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('date', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('date', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open date filters"></i> -->
      </div>
    </ng-template>
    <ng-template let-column="date" let-value="value" ngx-datatable-cell-template>
      <span *ngIf="value">{{ value | formatedDate: '-' }}</span>
      <span class="field-placeholder" *ngIf="!value">Add Date</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && isColumnDisplayed('type')" prop="type" name="Type" [width]="110">
    <ng-template ngx-datatable-header-template>
      <div class="column-header">
        <span class="column-label">Type</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('type', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('type', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open type filters"></i> -->
      </div>
    </ng-template>
    <ng-template let-column="type" let-value="value" ngx-datatable-cell-template>
      <span *ngIf="value">{{ getTypeDisplay(value) }}</span>
    </ng-template>
  </ngx-datatable-column>

  <!-- Category -->
  <ngx-datatable-column *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && isColumnDisplayed('category')" prop="invoiceLines" name="Category" [width]="200">
    <ng-template ngx-datatable-header-template>
      <div class="column-header">
        <span class="column-label">Category</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('category', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('category', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open category filters"></i> -->
      </div>
    </ng-template>
    <ng-template let-column="column" let-row="row" let-value="value" ngx-datatable-cell-template>
      <div class="category-row" *ngIf="!row?.isProcessed && row.invoiceLines.length < 2">
        <!-- SD-1235: a proper field (bordered, chevron, amber focus) and a panel on the body, so
             the cell no longer clips it to a 160px sliver. Inactive accounts are left out of the
             list itself rather than drawn as blank rows (see selectableAccounts). -->
        <ng-select [(ngModel)]="row.accountId" [items]="selectableAccounts" bindLabel="name" bindValue="id"
          [searchable]="true" [clearable]="false" (change)="onSelectAccount(row, $event)"
          placeholder="Select category" notFoundText="No matching category" appendTo="body"
          class="sd-cell-select" [ngModelOptions]="{standalone: true}">
          <ng-template ng-option-tmp let-item="item">
            <span class="sd-cell-select__option" [title]="item.name">{{ item.name }}</span>
            <span class="sd-cell-select__code" *ngIf="item.displayCode">{{ item.displayCode }}</span>
          </ng-template>
        </ng-select>
      </div>
      <div class="categories-wrapper" *ngIf="value?.length > 0"
        [ngClass]="shownCategoriesInvoiceId == row.id && value?.length > 0 ? 'expanded-row' : ''">
        <div class="category-row" *ngIf="value.length > 1 && shownCategoriesInvoiceId != row.id">Multiple Categories
        </div>
        <div class="category-row" *ngIf="value.length == 1 && row.accountName && row.isProcessed">{{row.accountName}}
        </div>
        <div *ngIf="shownCategoriesInvoiceId == row.id && value.length > 1"
          [ngClass]="shownCategoriesInvoiceId == row.id ? 'added-padding' : ''">
          <div class="category-row" *ngFor="let line of value">{{line.accountName}}</div>
        </div>
        <div class="show-details" *ngIf="value?.length > 1" (click)="showMoreCategories(row); $event.stopPropagation()">
          <span *ngIf="shownCategoriesInvoiceId != row.id">Show detail</span>
          <span *ngIf="shownCategoriesInvoiceId == row.id">Hide detail</span>
        </div>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <!-- Submitter - Updated to respect visibility toggle -->
  <ngx-datatable-column name="Submitter" prop="submitterName" [width]="150" 
    *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && isColumnDisplayed('submitter')">
    <ng-template ngx-datatable-header-template>
      <div class="column-header">
        <span class="column-label">Submitter</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('submitter', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('submitter', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open submitter filters"></i> -->
      </div>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div class="submitter-name category-row">
        <ng-container *ngIf="row.submitterName && row.submitterName.trim() !== ''">
          {{ row.submitterName }}
        </ng-container>
        <ng-container *ngIf="!row.submitterName || row.submitterName.trim() === ''">
          <span class="submitter-unknown">Unknown</span>
        </ng-container>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <!-- Tracking Category 1 -->
  <ngx-datatable-column [width]="100" *ngIf="selectedTrackingCategories?.length > 0 && screenBrakepoint == screenBrakepoints.MinWidth769px && isColumnDisplayed('tracking1')">
    <ng-template [width]="100" let-column="column" ngx-datatable-header-template>
      <div class="column-header">
        <span class="column-label">{{selectedTrackingCategories[0].name}}</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('tracking1', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('tracking1', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open tracking filters"></i> -->
      </div>
    </ng-template>
    <ng-template [width]="100" let-row="row" ngx-datatable-cell-template>
      <div *ngIf="row.invoiceLines?.length > 0">
        <div class="categories-wrapper">
          <div class="category-row"
            *ngIf="row.invoiceLines?.length > 1 && row.invoiceLines[0].trackingOptions?.length > 0 && row.invoiceLines[0].trackingOptions[0] && shownCategoriesInvoiceId != row.id">
            Multiple</div>
          <div class="category-row"
            *ngIf="row.invoiceLines?.length == 1 && row.invoiceLines[0].trackingOptions?.length > 0 && row.invoiceLines[0].trackingOptions?.length < 2">
            {{row.invoiceLines[0].trackingOptions[0]}}</div>
          <div class="category-row"
            *ngIf="row.invoiceLines?.length == 1 && row.invoiceLines[0].trackingOptions?.length > 1 && row.invoiceLines[0].trackingOptionNames?.length > 0">
            {{row.invoiceLines[0].trackingOptionNames[0]}}</div>
          <div *ngIf="shownCategoriesInvoiceId == row.id && row.invoiceLines?.length > 1">
            <div *ngFor="let line of row.invoiceLines"
              [ngClass]="shownCategoriesInvoiceId == row.id ? 'added-padding' : ''">
              <div class="category-row" *ngIf="line.trackingOptions[0]">{{line.trackingOptionNames[0]}}</div>
              <div class="category-row" *ngIf="!line.trackingOptions[0]" style="opacity: 0;">Text</div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <!-- Tracking Category 2 -->
  <ngx-datatable-column [width]="100" *ngIf="selectedTrackingCategories?.length > 1 && screenBrakepoint == screenBrakepoints.MinWidth769px && isColumnDisplayed('tracking2')">
    <ng-template [width]="100" let-column="column" ngx-datatable-header-template>
      <div class="column-header">
        <span class="column-label">{{selectedTrackingCategories[1].name}}</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('tracking2', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('tracking2', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open tracking filters"></i> -->
      </div>
    </ng-template>
    <ng-template [width]="100" let-row="row" ngx-datatable-cell-template>
      <div *ngIf="row.invoiceLines?.length > 0">
        <div class="categories-wrapper">
          <div class="category-row"
            *ngIf="row.invoiceLines?.length > 1 && row.invoiceLines[0].trackingOptions?.length > 0 && row.invoiceLines[0].trackingOptions[1] && shownCategoriesInvoiceId != row.id">
            Multiple</div>
          <div class="category-row"
            *ngIf="row.invoiceLines?.length == 1 && row.invoiceLines[0].trackingOptions?.length > 1 && row.invoiceLines[0].trackingOptionNames?.length > 0">
            {{row.invoiceLines[0].trackingOptionNames[1]}}</div>
          <div *ngIf="shownCategoriesInvoiceId == row.id && row.invoiceLines?.length > 1">
            <div *ngFor="let line of row.invoiceLines"
              [ngClass]="shownCategoriesInvoiceId == row.id ? 'added-padding' : ''">
              <div class="category-row" *ngIf="line.trackingOptions[1]">{{line.trackingOptionNames[1]}}</div>
              <div class="category-row" *ngIf="!line.trackingOptions[1]" style="opacity: 0;">Text</div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <!-- Tags -->
  <ngx-datatable-column name="Tags" prop="tags" [width]="220" [flexGrow]="0" [canAutoResize]="false"
    *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && isColumnDisplayed('tags')">
    <ng-template ngx-datatable-header-template>
      <div class="column-header">
        <span class="column-label">Tags</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('tags', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('tags', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open tags filters"></i> -->
      </div>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <ng-container *ngIf="row?.tags?.length">
        <app-tag-pill [tags]="row.tags" [showPlaceholderWhenEmpty]="false"
          (pillCleared)="deleteTag($event)"></app-tag-pill>
      </ng-container>
    </ng-template>
  </ngx-datatable-column>

  <!-- Total -->
  <ngx-datatable-column [width]="100" prop="totalOutstanding" name="Total" 
  *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && isColumnDisplayed('total')" [headerClass]="'align-right'" [cellClass]="'align-right'">
    <ng-template [width]="100" let-column="column" ngx-datatable-header-template>
      <div class="amountCellHeader column-header">
        <span class="column-label">Total</span>
        <!-- <i class="fa fa-filter header-filter-icon" title="Filter" (click)="onHeaderFilterClick('amount', $event); $event.stopPropagation()" (keydown.enter)="onHeaderFilterClick('amount', $event); $event.stopPropagation()" role="button" tabindex="0" aria-label="Open total filters"></i> -->
      </div>
    </ng-template>
    <ng-template [width]="100" let-row="row" ngx-datatable-cell-template>
      <div class="total-cell">
      <div class="tooltip-container" *ngIf="shownCategoriesInvoiceId != row.id" 
      (mouseenter)="showTotalInvoiceId = row?.id; tooltipValue = (row.amountDue === 'Infinity' ? row?.total : row.amountDue > 0 ? row?.amountDue : row.amountDue == 0 || row.amountDue == null ? 0.00 : row.amountDue < 0 ? row.amountDue : 0.00)"
      (mouseleave)="tooltipValue = ''">
        <span *ngIf="row.amountDue === 'Infinity'"> {{ row.total | number : '1.2-2'}}</span>
        <span *ngIf="row.amountDue > 0"> {{ row.amountDue | number : '1.2-2'}}</span>
        <span *ngIf="row.amountDue == 0 || row.amountDue == null"> {{ 0.00 | number : '1.2-2'}}</span>
        <span *ngIf="row.amountDue < 0"> {{row.amountDue | positiveNumber : '1.2-2'}}</span>
        <div class="custom-tooltip">
          <div> Sub Total: {{ row.subtotal | number : '1.2-2' }}</div>
          <div> Tax: {{ row.totalTax | number : '1.2-2' }}</div>
          <div> Total: {{ tooltipValue | number : '1.2-2' }}</div>
        </div>
      </div>
      <div class="categories-wrapper"
        [ngClass]="shownCategoriesInvoiceId == row.id && row.invoiceLines?.length > 0 ? 'added-padding' : ''"
        *ngIf="row.invoiceLines && row.invoiceLines.length > 0 && shownCategoriesInvoiceId == row.id">
        <div *ngIf="shownCategoriesInvoiceId == row.id">
          <div class="category-row" *ngFor="let line of row.invoiceLines">{{line.amountDue | number : '1.2-2'}}</div>
        </div>
      </div>
      <span class="show-amount-on-hover" *ngIf="shownCategoriesInvoiceId != row.id">
        <span class="currency-badge" *ngIf="row.unConvertedAmount > 0 && row.invoiceCurrency != 0">
          <img
            class="currency-flag-img"
            *ngIf="getCurrencyFlagUrl(row.invoiceCurrency) as flagUrl"
            [src]="flagUrl"
            alt=""
            aria-hidden="true"
          />
          {{row.invoiceCurrency}}
          <span class="currency-converted">
            ≈ {{row.unConvertedAmount | number : '1.2-2'}} {{defaultCurrency}}
          </span>
        </span>
      </span>
      </div>
     
    </ng-template>
  </ngx-datatable-column>

  <!-- Match -->
  <ngx-datatable-column
    *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px"
    name="Matches"
    [width]="84"
    [sortable]="false"
    [resizeable]="false"
    headerClass="align-center"
    cellClass="align-center">
    <ng-template ngx-datatable-header-template>
      <span class="column-label">Matches</span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <ng-container *ngIf="row?.isMatched || (row?.suggestedMatchCount > 0 && !row?.isMatched)">
        <ng-container *ngIf="row?.id?.toString() as invoiceId">
          <div
            class="match-pill-wrapper"
            (mouseenter)="onMatchPillHover(invoiceId, row?.isMatched)"
            (mouseleave)="onMatchPillLeave(invoiceId)">
            <button
              type="button"
              class="match-icon-btn"
              [ngClass]="row?.isMatched ? 'is-matched' : 'is-potential'"
              [attr.aria-label]="row?.isMatched ? 'Matched transaction' : (row?.suggestedMatchCount + ' potential matches')"
              (click)="row?.isMatched ? $event.preventDefault() : openSuggestedMatchesModal(row, $event)">
              <i *ngIf="row?.isMatched" class="fa fa-check"></i>
              <span *ngIf="!row?.isMatched">{{ row?.suggestedMatchCount }}</span>
            </button>
            <div class="match-panel" *ngIf="hoveredMatchPillId === invoiceId">
              <ng-container *ngIf="matchDetailsLoading[invoiceId]; else matchColPanelContent">
                <div class="match-panel-state">Loading {{ row?.isMatched ? 'matched transaction' : 'potential matches' }}…</div>
              </ng-container>
              <ng-template #matchColPanelContent>
                <div class="match-panel-state error" *ngIf="matchDetailsError[invoiceId]">
                  {{ matchDetailsError[invoiceId] }}
                </div>
                <ng-container *ngIf="!matchDetailsError[invoiceId]">
                  <div class="match-panel-heading">
                    {{ row?.isMatched ? 'Matched transaction' : 'Potential matches' }}
                  </div>
                  <ng-container *ngIf="getMatchDetailsPreview(invoiceId, row?.isMatched) as matchPreview">
                    <div class="match-row" *ngFor="let detail of matchPreview">
                      <div class="match-row__title">
                        <span>{{ detail.accountName || 'Account' }}</span>
                        <span>{{ detail.amount | number : '1.2-2' }}</span>
                      </div>
                      <div class="match-row__meta">
                        <span>{{ detail.transactionDate | date : 'dd MMM yyyy' }}</span>
                        <span>{{ detail.description || 'No description provided' }}</span>
                      </div>
                    </div>
                    <div class="match-panel-state" *ngIf="matchPreview.length === 0">
                      {{ row?.isMatched ? 'Matched transaction details are unavailable.' : 'No unreconciled data available.' }}
                    </div>
                  </ng-container>
                  <button
                    type="button"
                    class="match-panel-action"
                    *ngIf="!row?.isMatched"
                    (click)="openSuggestedMatchesModal(row, $event)">
                    Review & Match
                  </button>
                </ng-container>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-template>
  </ngx-datatable-column>

  <!-- Actions -->
  <ngx-datatable-column *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && status === statuses.inProcessing && isColumnDisplayed('actions')" name="Actions" [width]="120" [sortable]="false" [resizeable]="false" headerClass="align-center" cellClass="align-center">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div class="invoice-actions" *ngIf="shouldShowInvoiceActions(row)">
        <button
          *ngIf="canPublish && !row?.isProcessed"
          type="button"
          class="publish-btn"
          [ngClass]="{'is-loading': row?.isPublishing, 'is-disabled': !row?.required_Fields}"
          [disabled]="!row?.required_Fields || row?.isPublishing"
          [attr.title]="row?.required_Fields ? 'Publish Invoice' : 'Complete required fields to enable publishing'"
          (click)="onPublishClick(row, $event)">
          <span class="spinner" *ngIf="row?.isPublishing" aria-hidden="true"></span>
          <span class="label">{{ row?.isPublishing ? 'Publishing' : 'Publish' }}</span>
        </button>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <!-- Actions (Combined: per-row, based on each row's processed state) -->
  <ngx-datatable-column *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && status === statuses.combined && isColumnDisplayed('actions')" name="Actions" [width]="120" [sortable]="false" [resizeable]="false" headerClass="align-center" cellClass="align-center">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div class="invoice-actions">
        <button
          *ngIf="!row?.isProcessed && canPublish"
          type="button"
          class="publish-btn"
          [ngClass]="{'is-loading': row?.isPublishing, 'is-disabled': !row?.required_Fields}"
          [disabled]="!row?.required_Fields || row?.isPublishing"
          [attr.title]="row?.required_Fields ? 'Publish Invoice' : 'Complete required fields to enable publishing'"
          (click)="onPublishClick(row, $event)">
          <span class="spinner" *ngIf="row?.isPublishing" aria-hidden="true"></span>
          <span class="label">{{ row?.isPublishing ? 'Publishing' : 'Publish' }}</span>
        </button>
        <button
          *ngIf="row?.isProcessed"
          type="button"
          class="publish-btn"
          (click)="onUpdateClick(row, $event)">
          <span class="label">Update</span>
        </button>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <!-- Actions (Processed) -->
  <ngx-datatable-column *ngIf="screenBrakepoint == screenBrakepoints.MinWidth769px && status === statuses.processed && isColumnDisplayed('actions')" name="Actions" [width]="120" [sortable]="false" [resizeable]="false" headerClass="align-center" cellClass="align-center">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <div class="invoice-actions">
        <button
          type="button"
          class="publish-btn"
          (click)="onUpdateClick(row, $event)">
          <span class="label">Update</span>
        </button>
      </div>
    </ng-template>
  </ngx-datatable-column>

    <!-- Total Mobile -->
    <ngx-datatable-column [width]="50" prop="totalOutstanding" name="Total" 
    *ngIf="screenBrakepoint != screenBrakepoints.MinWidth769px && isColumnDisplayed('total')" [headerClass]="'align-right'" [cellClass]="'align-right'">
      <ng-template [width]="50" let-row="row" ngx-datatable-cell-template 
      (mouseenter)="tooltipValue = row?.total"
      (mouseleave)="tooltipValue = ''" >
        <div class="amountcell mobile align-right" *ngIf="shownCategoriesInvoiceId != row.id" >
          <div class="total-cell">
            <span *ngIf="row.amountDue === 'Infinity'"> {{ row.total | number : '1.2-2'}}</span>
            <span *ngIf="row.amountDue > 0"> {{ row.amountDue | number : '1.2-2'}}</span>
            <span *ngIf="row.amountDue == 0 || row.amountDue == null"> {{ 0.00 | number : '1.2-2'}}</span>
            <span class="show-amount-on-hover" *ngIf="shownCategoriesInvoiceId != row.id">
              <span class="currency-badge" *ngIf="row.unConvertedAmount > 0 && row.invoiceCurrency != 0">
                <img
                  class="currency-flag-img"
                  *ngIf="getCurrencyFlagUrl(row.invoiceCurrency) as flagUrl"
                  [src]="flagUrl"
                  alt=""
                  aria-hidden="true"
                />
                {{row.invoiceCurrency}}
                <span class="currency-converted">
                  ≈ {{row.unConvertedAmount | number : '1.2-2'}} {{defaultCurrency}}
                </span>
              </span>
              <div class="custom-tooltip" *ngIf="tooltipValue">
                {{ tooltipValue }}
              </div>
            </span>
          </div>
        </div>
      </ng-template>
    </ngx-datatable-column>


  <ngx-datatable-footer>
    <ng-template ngx-datatable-footer-template let-rowCount="maxCount" let-tablePageSize="pageSize"
      let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
      <div class="pagination-container" *ngIf="!infiniteScroll && (status == 'Processed' || status == 'Combined') && maxCount > 0">
        <div class="results-info">
          <span class="results-count">
            {{ invoices?.length || 0 }} of {{ maxCount || 0 }} {{ (status === 'Processed' || status === 'Combined') ? 'invoices' : 'items' }}
            <span class="filter-indicator" *ngIf="maxCount !== invoices?.length">
              (filtered)
            </span>
          </span>
        </div>
        <div class="pagination-controls">
          <div class="page-size-selector">
            <label for="page-size-select">Show:</label>
            <select id="page-size-select" [(ngModel)]="pageSize" (change)="onPageSizeChange($event)"
              title="Select page size">
              <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
            </select>
          </div>
          <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="page"
            [size]="tablePageSize" [count]="maxCount" (change)="table.onFooterPage($event); clickOn($event)">
          </datatable-pager>
        </div>
      </div>
    </ng-template>
  </ngx-datatable-footer>
  <!-- INLINE HEADER FILTER POPOVER - temporarily commented out
  <div #headerFilterPopover class="header-filter-popover" *ngIf="activeHeaderFilterField" [ngStyle]="popoverStyle">
    <div class="popover-inner">
      <div *ngIf="activeHeaderFilterField === 'supplier'">
        <div class="popover-title">Supplier <span class="selected-count" *ngIf="headerSelectedValues?.length">({{ headerSelectedValues.length }})</span></div>
        <div class="popover-actions-row">
          <a class="action-link" (click)="selectAllFilteredOptions()">Select all</a>
          <a class="action-link" (click)="clearHeaderSelection()">Clear</a>
        </div>
        <input class="popover-search-input" type="text" placeholder="Search suppliers" [(ngModel)]="supplierSearchTerm" (ngModelChange)="filterSupplierOptions($event)" />
        <div class="popover-choices">
          <label *ngFor="let s of supplierFilteredOptions">
            <input type="checkbox" (change)="toggleHeaderFilterChoice(s, $event.target.checked)" [checked]="headerSelectedValues?.includes(s)"> <span class="choice-label">{{ s }}</span>
          </label>
          <div class="no-options" *ngIf="supplierFilteredOptions.length === 0">No suppliers</div>
        </div>
      </div>

      <div *ngIf="activeHeaderFilterField === 'category'">
        <div class="popover-title">Category <span class="selected-count" *ngIf="headerSelectedValues?.length">({{ headerSelectedValues.length }})</span></div>
        <div class="popover-actions-row">
          <a class="action-link" (click)="selectAllFilteredOptions()">Select all</a>
          <a class="action-link" (click)="clearHeaderSelection()">Clear</a>
        </div>
        <div class="popover-choices">
          <label *ngFor="let aName of categoriesFilteredOptions">
            <input type="checkbox" (change)="toggleHeaderFilterChoice(aName, $event.target.checked)" [checked]="headerSelectedValues?.includes(aName)"> <span class="choice-label">{{ aName }}</span>
          </label>
          <div class="no-options" *ngIf="categoriesFilteredOptions.length === 0">No categories</div>
        </div>
      </div>

      <div *ngIf="activeHeaderFilterField === 'tags'">
        <div class="popover-title">Tags <span class="selected-count" *ngIf="headerSelectedValues?.length">({{ headerSelectedValues.length }})</span></div>
        <div class="popover-actions-row">
          <a class="action-link" (click)="selectAllFilteredOptions()">Select all</a>
          <a class="action-link" (click)="clearHeaderSelection()">Clear</a>
        </div>
        <input class="popover-search-input" type="text" placeholder="Search tags" [(ngModel)]="tagsSearchTerm" (ngModelChange)="filterTagOptions($event)" />
        <div class="popover-choices">
          <label *ngFor="let t of tagsFilteredOptions">
            <input type="checkbox" (change)="toggleHeaderFilterChoice(t, $event.target.checked)" [checked]="headerSelectedValues?.includes(t)"> <span class="choice-label">{{ t }}</span>
          </label>
          <div class="no-options" *ngIf="tagsFilteredOptions.length === 0">No tags</div>
        </div>
      </div>

      <div *ngIf="activeHeaderFilterField === 'date'">
        <div class="popover-title">Date</div>
        <app-date-time-picker (getDateRange)="onHeaderDateRangeSelected($event)" [placeholder]="'Select Date'"></app-date-time-picker>
      </div>

      <div *ngIf="activeHeaderFilterField === 'tracking1'">
        <div class="popover-title">Tracking</div>
        <div class="popover-choices">
          <label *ngFor="let o of (selectedTrackingCategories[0]?.options || [])">
            <input type="checkbox" (change)="toggleHeaderFilterChoice(o.name, $event.target.checked)" [checked]="headerSelectedValues?.includes(o.name)"> {{ o.name }}
          </label>
        </div>
      </div>

      <div *ngIf="activeHeaderFilterField === 'tracking2'">
        <div class="popover-title">Tracking</div>
        <div class="popover-choices">
          <label *ngFor="let o of (selectedTrackingCategories[1]?.options || [])">
            <input type="checkbox" (change)="toggleHeaderFilterChoice(o.name, $event.target.checked)" [checked]="headerSelectedValues?.includes(o.name)"> {{ o.name }}
          </label>
        </div>
      </div>

      <div *ngIf="activeHeaderFilterField === 'submitter'">
        <div class="popover-title">Submitter</div>
        <div class="popover-choices">
          <label *ngFor="let s of (submitters || [])">
            <input type="checkbox" (change)="toggleHeaderFilterChoice(s, $event.target.checked)" [checked]="headerSelectedValues?.includes(s)"> {{ s }}
          </label>
        </div>
      </div>

      <div *ngIf="activeHeaderFilterField === 'type'">
        <div class="popover-title">Type <span class="selected-count" *ngIf="headerSelectedValues?.length">({{ headerSelectedValues.length }})</span></div>
        <div class="popover-actions-row">
          <a class="action-link" (click)="selectAllFilteredOptions()">Select all</a>
          <a class="action-link" (click)="clearHeaderSelection()">Clear</a>
        </div>
        <input class="popover-search-input" type="text" placeholder="Search types" [(ngModel)]="typeSearchTerm" (ngModelChange)="filterTypeOptions($event)" />
        <div class="popover-choices">
          <label *ngFor="let t of typeFilteredOptions">
            <input type="checkbox" (change)="toggleHeaderFilterChoice(t, $event.target.checked)" [checked]="headerSelectedValues?.includes(t)"> <span class="choice-label">{{ t }}</span>
          </label>
          <div class="no-options" *ngIf="typeFilteredOptions.length === 0">No types</div>
        </div>
      </div>

      <div *ngIf="activeHeaderFilterField === 'amount'">
        <div class="popover-title">Amount</div>
        <div class="amount-row">
          <input type="number" placeholder="Min" [(ngModel)]="headerAmountMin" />
          <span>—</span>
          <input type="number" placeholder="Max" [(ngModel)]="headerAmountMax" />
        </div>
      </div>

      <div class="popover-actions">
        <button class="btn btn-secondary" (click)="closeHeaderFilterPopover()">Cancel</button>
        <button class="btn btn-primary" (click)="applyHeaderFilter()">Apply</button>
      </div>
    </div>
  </div>
  -->
</ngx-datatable>

<div class="suggested-modal-backdrop" *ngIf="showSuggestedMatchesModal" (click)="closeSuggestedMatchesModal()">
  <div class="suggested-modal">
    <div class="modal-header">
      <div>
        <h3>Match Transaction</h3>
        <p *ngIf="selectedInvoiceForMatch">
          {{ selectedInvoiceForMatch?.supplierName || 'Invoice' }} · {{ selectedInvoiceForMatch?.invoiceNumber || 'Pending Number' }}
        </p>
      </div>
      <button type="button" class="modal-close" aria-label="Close" (click)="closeSuggestedMatchesModal()">
        &times;
      </button>
    </div>
    <div class="modal-body">
      <ng-container *ngIf="selectedInvoiceForMatch as invoice">
        <ng-container *ngIf="matchDetailsLoading[invoice.id?.toString()]">
          <div class="match-panel-state">Loading potential matches…</div>
        </ng-container>
        <ng-container *ngIf="!matchDetailsLoading[invoice.id?.toString()]">
          <div class="match-panel-state error" *ngIf="matchDetailsError[invoice.id?.toString()]">
            {{ matchDetailsError[invoice.id?.toString()] }}
          </div>
          <ng-container *ngIf="!matchDetailsError[invoice.id?.toString()]">
            <label class="modal-option" *ngFor="let transaction of invoiceMatchDetails[invoice.id?.toString()]" (click)="selectSuggestedTransaction(transaction)">
              <input
                type="radio"
                name="suggested-transaction"
                [value]="transaction.unreconciledReportId"
                [checked]="transaction.unreconciledReportId === selectedTransactionIdForMatch"
                (change)="selectSuggestedTransaction(transaction); $event.stopPropagation()"
              />
              <div class="option-content">
                <div class="option-title">
                  <span>{{ transaction.accountName || 'Account' }}</span>
                  <span>{{ transaction.amount | number : '1.2-2' }}</span>
                </div>
                <div class="option-meta">
                  <span>{{ transaction.transactionDate | date : 'dd MMM yyyy' }}</span>
                  <span>{{ transaction.description || 'No description provided' }}</span>
                </div>
              </div>
            </label>
            <div class="match-panel-state" *ngIf="(invoiceMatchDetails[invoice.id?.toString()] || []).length === 0">
              No unreconciled data available.
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <div class="modal-footer">
      <button type="button" class="secondary-btn" (click)="closeSuggestedMatchesModal()" [disabled]="modalMatchProcessing">
        Cancel
      </button>
      <button
        type="button"
        class="primary-btn"
        (click)="confirmSuggestedMatch()"
        [disabled]="modalMatchProcessing || !selectedTransactionIdForMatch"
      >
        <span *ngIf="!modalMatchProcessing">Match Transaction</span>
        <span *ngIf="modalMatchProcessing" class="btn-spinner"></span>
      </button>
    </div>
  </div>
</div>


<div [ngClass]="showSidebar ? 'sidenav sidenav-show sidebar40' : 'sidenav'">
  <a [routerLink]="" class="closebtn" (click)="toggleFilter()" style="margin-bottom: 10px;">&times;</a>
  <div class="sidenav_in">
    <div class="form-group">
      <app-upload-document [isHorizontalDirection]=isHorizontalDirection></app-upload-document>
    </div>
  </div>
</div>